
import { createSearchModel } from './searchModel'
import { html as dom, empty } from './../utility/html'
import naturalLanguageJoin from './../utility/naturalLanguageJoin'
import expand from './../modules/expand'


// components


const filtersClearButton = (el, model) => {
	const filtersCountMap = model.filtersCount()
	const hasSelected = hasFilters(model.get(), filtersCountMap)
	let text = []
	if (hasSelected) text.push('filters')
	if (model.get('search')) text.push('search')
	text = text.length > 1 ? 'Clear search & filters' : `Clear ${text[0]}`
	el.innerHTML = ``
	if (hasSelected || model.get('search')) {
		const button = dom(`<a class="button button--outline button--block margin-bottom-3" href="${pageUrl()}">${text}</a>`)
		button.firstChild.addEventListener('click', event => {
			event.preventDefault()
			model.set('subject', [], false)
			model.set('location', [], false)
			model.set('jobType', [], false)
			model.set('search', "", false)
			model.set('search', "") // trigger reload
		})
		el.appendChild(button)
	}
}

const createFilters = () => {

	let previousSelectionLength = {
		subject : 0,
		location : 0,
		jobType : 0,
	}

	return (el, model, triggeredBy) => {

		const subjectLength = model.get('subject').filter(String).length
		const locationLength = model.get('location').filter(String).length
		const jobTypeLength = model.get('jobType').filter(String).length

		const els = {
			subject : el.querySelector('.js-searchpage__filters__subject'),
			location : el.querySelector('.js-searchpage__filters__location'),
			type : el.querySelector('.js-searchpage__filters__type')
		}

		// console.log({subjectLength, locationLength, jobTypeLength})

		const filtersCountMap = model.filtersCount()

		const subject = checkboxes('Subject', 'subject[]', model, filtersCountMap)
		if (triggeredBy !== 'subject' || previousSelectionLength.subject > subjectLength) {
			els.subject.innerHTML = ``
			subject && els.subject.appendChild(subject)
		}

		const location = checkboxes('Location', 'location[]', model, filtersCountMap)
		if (triggeredBy !== 'location' || previousSelectionLength.location > locationLength) {
			els.location.innerHTML = ``
			location && els.location.appendChild(location)
		}

		const type = checkboxes('Level of study', 'jobType[]', model, filtersCountMap)
		if (triggeredBy !== 'jobType' || previousSelectionLength.jobType > jobTypeLength) {
			els.type.innerHTML = ``
			type && els.type.appendChild(type)
		}

		previousSelectionLength.subject = subjectLength
		previousSelectionLength.location = locationLength
		previousSelectionLength.jobType = jobTypeLength
	}
}



const showing = (el, model) => {
	const filtersCountMap = model.filtersCount()
	const showFilters = hasFilters(model.get(), filtersCountMap)
	const jobCount = model.get('jobs').length || 0
	el.innerHTML = ``
	el.appendChild(dom(`Showing <strong>${jobCount}</strong> ${jobCount === 1 ? 'role' : 'roles'} ${showFilters && `<span class="fade">(filtered)</span>` || ''}`))
}

const checkboxes = (title, inputName, model, filtersCountMap, limit = 8) => {

	const baseName = inputName.replace(/\[\]$/, '')

	const values = model.filters()[baseName] || []
	const query = model.get(baseName) || []

	const checkboxes = values.map(value => {
		return {
			name : inputName,
			baseName : baseName,
			value : value,
			checked : query.indexOf(value) > -1,
			count : filtersCountMap[baseName] && filtersCountMap[baseName][value] || 0
		}
	}).filter(x => x.count > 0)

	const items = checkboxes.slice(0, limit).map(val => checkbox(val, model))
	const moreItems = checkboxes.slice(limit).map(val => checkbox(val, model))

	if (!items.length) return

	const el = dom(`<fieldset><legend>${title}</legend></fieldset>`)
	const fieldset = el.querySelector('fieldset')

	items.map(checkbox => fieldset.appendChild(checkbox))
	
	if (!moreItems.length) return el

	const moreItemsEl = dom(`
		<div id="filters-more-${baseName}"></div>
		<button class="button-expand margin-top-2 margin-bottom-1" data-expand="filters-more-${baseName}" aria-expanded="false">
			<i class="button-expand__icon"></i>
			<span class="button-expand__text-open">Hide</span>
			<span class="button-expand__text-closed">More</span>
		</button>
	`)
	
	const container = moreItemsEl.querySelector(`#filters-more-${baseName}`)
	const button = moreItemsEl.querySelector('button')

	expand(button, (open, button, content) => {
		const openClass = 'button-expand--open'
		open ? button.classList.add(openClass) : button.classList.remove(openClass)
	}, moreItemsEl)

	moreItems.map(checkbox => container.appendChild(checkbox))
	fieldset.appendChild(moreItemsEl)

	return el
}

const checkbox = ({ checked, name, baseName, value, count }, model) => {

	const el = dom(`
		<label class="checkbox checkbox--stack checkbox--search">
			<input type="checkbox" ${checked ? 'checked' : ''} name="${name}" value="${value}">
			<span class="checkbox__label">
				${value} <span>(${count})</span>
			</span>
		</label>
	`)

	el.querySelector('input').addEventListener('change', event => {

		const values = model.get(baseName)
		if (event.currentTarget.checked) {
			model.set(baseName, [
				...values,
				event.currentTarget.value
			])
		} else {
			const index = values.indexOf(event.currentTarget.value)
			values.splice(index, 1)
			model.set(baseName, values)
		}	
	})

	return el
}

function jobs(el, jobs) {
	if (jobs.length) {
		el.innerHTML = ''
		jobs.map(data => el.appendChild(job(data)))
	} else {
		el.innerHTML = `
			<div id="search-no-results">
				<h2 class="heading-3 margin-top-0">No jobs found</h2>
				<p>We couldn’t find any results for your search. Try changing your search term, or removing some filters.</p>
				<a class="button button--outline button--block@medium-max hide@medium" href="${pageUrl()}">Clear all</a>
			</div>
		`
	}
}

function job({ applyUrl, title, jobType, location, sector, internalLink, internal }) {

	const locations = (location.length > 3) ? 'Multiple locations' : naturalLanguageJoin(location, 'or')
	const sectors = (sector.length > 3) ? 'Across multiple sectors' : naturalLanguageJoin(sector)
	const locationText = [locations, sectors].filter(Boolean).join(' — ')
	const link = internal ? internalLink : applyUrl

	return dom(`
		<a target="_blank" rel="noopener noreferrer" href="${link}" class="job-tile job-tile--smaller">
			<div class="job-tile__title">${title}</div>
			<div class="job-tile__sub">
				${ jobType && `<div class="job-tile__sub__item">${ jobType }</div>` || "" }
				${ locations && `<div class="job-tile__sub__item"><i class="icon icon--location-pin"></i>${ locations }</div>` || "" }
			</div>
		</a>
	`)
}


export default function init() {

	const form = document.querySelector('#search-form')
	if (!form) return

	// model
	const model = createSearchModel()

	// get render containers
	const searchInputEl = form.querySelector('.js-searchpage__search')
	const jobsEl = form.querySelector('.js-searchpage__jobs')
	const filtersEl = form.querySelector('.js-searchpage__filters')
	const filtersClearEl = form.querySelector('.js-searchpage__filters__clear')
	const filtersToggleEl = form.querySelector('.js-searchpage__filters__mobile-toggle')
	const showingEl = form.querySelector('.js-searchpage__showing-text')

	const filters = createFilters()
	
	// permanent els
	const textInputHandler = (e) => model.set(searchInputEl.name, searchInputEl.value)
	searchInputEl.addEventListener('input', textInputHandler)

	function render(updatedKey, updatedValue, model, triggeredBy) {
		if (updatedKey === 'search' && searchInputEl.value !== updatedValue) searchInputEl.value = updatedValue
		if (updatedKey === 'jobs') {
			jobs(jobsEl, model.get('jobs'))
			filtersClearButton(filtersClearEl, model)
			filters(filtersEl, model, triggeredBy)
			showing(showingEl, model)
		}

		if (updatedKey === 'loading') {
			if (updatedValue) {
				filtersEl.classList.add('js-loading')
			} else {
				filtersEl.classList.remove('js-loading')
			}
		}
	}

	model.subscribe(({ key, value, triggeredBy }) => render(key, value, model, triggeredBy))
	model.run()

	form.addEventListener('submit', event => {
		event.preventDefault()
		model.run()
	})
}


// helpers

function pageUrl() {
	return location.protocol + '//' + location.host + location.pathname
}

function hasFilters(data, filtersCountMap) {
	let hasFilters = false
	;['jobType', 'location', 'subject'].forEach(filter => {
		const userValues = [data[filter] || null].filter(Boolean).flat()
		userValues.forEach(value => {
			const hasCount = filtersCountMap[filter] && filtersCountMap[filter][value] || null
			hasFilters = true
		})
	})
	return hasFilters
}